import { HttpClient, HttpEvent, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { IFile } from '../../../../models/file.model';
import { ISibasiHTTPResponse } from '../../../../models/sibasiHTTPResponse.model';
import * as XLSX from 'xlsx';
import { IInventoryItem } from '../../../../models/inventory.model';
import { IPatient } from '../../../../models/patient.model';
import { IClinic } from '../../../../models/clinic.model';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  worksheet: any;

  constructor(
    private httpClient: HttpClient
  ) { }

  // uploadFile(file: FormData): Observable<HttpEvent<any>> {

  //   const req = new HttpRequest('POST', `${environment.api_url}/files/upload`, file, {
  //     reportProgress: true,
  //     responseType: 'json'
  //   });

  //   return this.httpClient.request(req);
  // }

  uploadFile(file: FormData, uploadURL: string): Observable<HttpEvent<any>> {

    const req = new HttpRequest('POST', `${environment.api_url}/${uploadURL}`, file, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.httpClient.request(req);
  }

  getFilesByModuleId(moduleId: string): Observable<ISibasiHTTPResponse<IFile[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<IFile[]>>(`${environment.api_url}/files/getModuleFilesByModuleItemId/${moduleId}`);
  }
  getImageFileById(fileId: string): Observable<Blob> {
    return this.httpClient.get(`${environment.api_url}/files/downloadImagesOnly/${fileId}`, { responseType: 'blob' });
  }
  getPDFFileById(fileId: string): Observable<Blob> {
    return this.httpClient.get(`${environment.api_url}/files/downloadFile/${fileId}`, { responseType: 'blob' }).pipe(
      map(res => {
        var fileURL = URL.createObjectURL(res);
        window.open(fileURL);
        return res;
      })
    );
  }

  deleteFile(fileRefId: string): Observable<ISibasiHTTPResponse<IFile>> {
    return this.httpClient.delete<ISibasiHTTPResponse<IFile>>(`${environment.api_url}/files/delete/${fileRefId}`);
  }
  deleteFileByRefId(fileRefId: string): Observable<ISibasiHTTPResponse<IFile>> {
    return this.httpClient.delete<ISibasiHTTPResponse<IFile>>(`${environment.api_url}/files/sample/delete/${fileRefId}`);
  }
  downloadFile(id: string): Observable<Blob> {
    return this.httpClient.get(`${environment.api_url}/files/downloadfile/${id}`, { responseType: 'blob' });
  }
  downloadImageFile(id: string): Observable<Blob> {
    return this.httpClient.get(`${environment.api_url}/files/downloadImagesOnly/${id}`, { responseType: 'blob' });
  }

  readExcel(fileUploaded: File): any {
    const readFile = new FileReader();
    readFile.onload = (e) => {
      const storeData: any = readFile.result;
      const data = new Uint8Array(storeData);
      const arr = new Array();
      for (let i = 0; i !== data.length; ++i) { arr[i] = String.fromCharCode(data[i]); }
      const bstr = arr.join('');
      const workbook = XLSX.read(bstr, { type: 'binary' });
      const firstSheetName = workbook.SheetNames[0];
      this.worksheet = workbook.Sheets[firstSheetName];
    };
    readFile.readAsArrayBuffer(fileUploaded);
  }

  readAsJson(): any {
    let jsonData;
    jsonData = XLSX.utils.sheet_to_json(this.worksheet, { raw: false });
    // jsonData = JSON.stringify(jsonData);
    return jsonData;
  }

  bulkUploadInventoryItems(inventoryItems: IInventoryItem[]): Observable<ISibasiHTTPResponse<IInventoryItem[]>> {
    return this.httpClient.post<ISibasiHTTPResponse<IInventoryItem[]>>(`${environment.api_url}/inventory/item/many/bulk`, inventoryItems);
  }

  bulkUploadPatients(patients: IPatient[]): Observable<ISibasiHTTPResponse<IPatient[]>> {
    return this.httpClient.post<ISibasiHTTPResponse<IPatient[]>>(`${environment.api_url}/patient/many/bulk`, patients);
  }

  bulkUploadClinics(clinics: IClinic[]): Observable<ISibasiHTTPResponse<IClinic[]>> {
    return this.httpClient.post<ISibasiHTTPResponse<IClinic[]>>(`${environment.api_url}/clinic/many/bulk`, clinics);
  }
}
